// ==============================|| BUYER-REQ — the gate lags the save by about a second ||========== //
//
// Commerce's purchase gate reads its OWN mirror of "is this buyer's profile complete"
// (commerce.buyer_profile_readiness), fed by Billing's `billing.buyer_profile.changed` event through the
// outbox and the broker — measured ~1 s on the dev stack (2026-10-15). So a buyer who completes their profile
// in the dialog and is put straight back onto "pay" or "choose plan" can be refused with the very 422 they
// just fixed.
//
// The client therefore retries THAT refusal, and only that one, for a short while after a profile save in
// this tab (see client.ts). Outside the window a 422 is the truth and surfaces at once — a genuinely
// incomplete profile must not spin.
//
// ⚠ THE RETRY USES A NEW Idempotency-Key. The server stores every < 500 response under its key and replays it
// for 24 h, so a retry with the same key would replay the 422 forever. A NEW key is safe here precisely
// because the refused request changed nothing.

const WINDOW_MS = 15_000;
let savedAt = 0;

/** Call after a buyer invoice profile save succeeds (the gate dialog, the Payment tab). */
export function noteBuyerProfileSaved(now: number = Date.now()): void {
  savedAt = now;
}

/** True within the window after the last profile save. */
export function buyerProfileJustSaved(now: number = Date.now()): boolean {
  return savedAt > 0 && now - savedAt < WINDOW_MS;
}

/** How many times, and how far apart — ~4 s in all, comfortably past the measured lag. */
export const BUYER_PROFILE_SYNC_RETRY = { attempts: 6, delayMs: 700 } as const;

/** The `type` suffix of Commerce's 422 "complete your buyer profile first" refusal. */
export const BUYER_PROFILE_INCOMPLETE_TYPE_SUFFIX = 'commerce-buyer-profile-incomplete';
